import axios from 'axios';

const list = (data) => axios.get('/safe/conf/list', data);
const save = (data) => axios.post('/safe/conf/save', data);


export default {
  list,
  save,

}


